'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingGTM = function trackingGTM(products) {
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    'event': 'acn_view_item',
    'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
    'ecommerce': {
      'currency': window.bvaccel.currency.currencyCode,
      'value': Number(products[0].price),
      'items': products
    }
  });
};

var variantChange = function variantChange(event) {
  event.stopImmediatePropagation();
  if (event.target.getAttribute('data-available') === 'true') {
    var gtmData = event.target.getAttribute('data-products');
    trackingGTM(JSON.parse(gtmData));
    PubSub.publish(_Constants2.default.updateWinVariant, {
      baseProduct: event.target.dataset.baseProduct,
      variantID: event.target.dataset.id,
      variantPrice: event.target.dataset.price,
      variantAvailable: event.target.dataset.available
    });
  }
};

var bindActions = exports.bindActions = function bindActions() {
  $(document).on('click', _Dom2.default.windowsVariantSelect, variantChange);
};